import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CompanyComment,
  CreateOrUpdateCompanyCommentRequest,
  HttpResponse,
} from "@/types";

export function useCreateCompanyComment() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createCompanyCommentRequest,
    }: {
      createCompanyCommentRequest: CreateOrUpdateCompanyCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-comments`;
      const res = await guacHttpClient.post<
        CompanyComment,
        HttpResponse<CompanyComment>,
        CreateOrUpdateCompanyCommentRequest
      >(path, createCompanyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
